import React from 'react';
import { useFormContext } from 'react-hook-form';
import AddressForm from '../address-form/AddressForm';
import './Step3PickupInfo.scss';

const Step3PickupInfo = ({ readOnly = false }) => {
  const { register, formState: { errors } } = useFormContext();

  return (
    <div className="step-3-pickup-info">
      <fieldset disabled={readOnly}>
        <AddressForm 
          title="Pickup Location" 
          prefix="pickup"
          required={true}
        />
        
        <div className="pickup-notes-section">
          <div className="form-group full-width">
            <label htmlFor="pickup.notes">
              Picked Up Notes
            </label>
            <textarea
              id="pickup.notes"
              placeholder="Text"
              rows={4}
              {...register('pickup.notes')}
              className={errors.pickup?.notes ? 'error' : ''}
            />
            {errors.pickup?.notes && (
              <span className="error-message">{errors.pickup.notes.message}</span>
            )}
          </div>
        </div>
      </fieldset>
    </div>
  );
};

export default Step3PickupInfo;














